import { ColumnDef } from '@tanstack/react-table'
import { Badge } from '@/common/ui/badge'
import { TOURNAMENT_PLAYER_STATUS_BADGE_MAP } from '@/modules/tournament/constants'
import { format } from 'date-fns'
import { th } from 'date-fns/locale'
import type { components } from '@/schema'

type TournamentPlayer = components['schemas']['AdminTournamentPlayerResponse']

export const tournamentPlayersColumns: ColumnDef<TournamentPlayer>[] = [
	{
		accessorKey: 'finalRank',
		header: 'อันดับ',
		cell: ({ row }) => {
			const rank = row.original.finalRank
			if (!rank) return <span className="text-muted-foreground">-</span>
			return <div className="text-center font-bold">#{rank}</div>
		},
	},
	{
		accessorKey: 'playerPhone',
		header: 'ผู้เล่น',
		cell: ({ row }) => {
			const player = row.original
			return (
				<div>
					<div className="font-medium">{player.playerPhone}</div>
					{player.playerUsername && (
						<div className="text-xs text-muted-foreground">
							{player.playerUsername}
						</div>
					)}
				</div>
			)
		},
	},
	{
		accessorKey: 'status',
		header: 'สถานะ',
		cell: ({ row }) => {
			const status = row.original.status
			const variant = TOURNAMENT_PLAYER_STATUS_BADGE_MAP[status] || 'default'
			const label =
				status === 'PENDING'
					? 'รอดำเนินการ'
					: status === 'QUALIFIED'
						? 'ผ่านคุณสมบัติ'
						: status === 'ACTIVE'
							? 'กำลังแข่งขัน'
							: status === 'DISQUALIFIED'
								? 'ถูกตัดสิทธิ์'
								: 'เสร็จสิ้น'
			return <Badge variant={variant}>{label}</Badge>
		},
	},
	{
		accessorKey: 'totalPoints',
		header: 'คะแนนรวม',
		cell: ({ row }) => {
			return (
				<div className="text-center font-semibold">
					{row.original.totalPoints.toLocaleString()}
				</div>
			)
		},
	},
	{
		accessorKey: 'totalWins',
		header: 'ชนะ',
		cell: ({ row }) => {
			return (
				<div className="text-center">
					{row.original.totalWins.toLocaleString()} ครั้ง
				</div>
			)
		},
	},
	{
		accessorKey: 'currentStreak',
		header: 'ชุดต่อเนื่อง',
		cell: ({ row }) => {
			return (
				<div className="text-center">
					<div>{row.original.currentStreak} ครั้ง</div>
					<div className="text-xs text-muted-foreground">
						สูงสุด: {row.original.longestStreak}
					</div>
				</div>
			)
		},
	},
	{
		accessorKey: 'totalBetAmount',
		header: 'ยอดเดิมพันรวม',
		cell: ({ row }) => {
			return `฿${Number(row.original.totalBetAmount).toLocaleString()}`
		},
	},
	{
		accessorKey: 'totalTransactions',
		header: 'จำนวนธุรกรรม',
		cell: ({ row }) => {
			return (
				<div className="text-center">
					{row.original.totalTransactions.toLocaleString()} ครั้ง
				</div>
			)
		},
	},
	{
		accessorKey: 'prizeAmount',
		header: 'รางวัล',
		cell: ({ row }) => {
			const prizeAmount = row.original.prizeAmount
			if (!prizeAmount) return <span className="text-muted-foreground">-</span>
			return (
				<div className="font-semibold text-green-600">
					฿{Number(prizeAmount).toLocaleString()}
				</div>
			)
		},
	},
	{
		accessorKey: 'joinedAt',
		header: 'วันที่เข้าร่วม',
		cell: ({ row }) => {
			return format(new Date(row.original.joinedAt), 'dd MMM yyyy HH:mm', {
				locale: th,
			})
		},
	},
]
